import { render } from "./FeaturedCarousel.vue?vue&type=template&id=0b13281e&scoped=true"
import script from "./FeaturedCarousel.vue?vue&type=script&lang=js"
export * from "./FeaturedCarousel.vue?vue&type=script&lang=js"

import "./FeaturedCarousel.vue?vue&type=style&index=0&id=0b13281e&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b13281e"]])

export default __exports__